import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { useAppDispatch } from '../../../redux/stores/hooks';
import { createHelpAction } from '@redux/actions/help';
import { useNavigate } from "react-router-dom";
import { ROUTES } from '@components/consts';
import AddIcon from '@mui/icons-material/Add';
import { Editor } from '@tinymce/tinymce-react';
import { getEditorConfiguration } from './config';

export default function CreateHelp() {
  const editorRef = useRef(null);
  const dispatch = useAppDispatch();
  const [title, setTitle] = useState('');
  const [order, setOrder] = useState(0);
  const [content, setContent] = useState('');
  const navigate = useNavigate();



  const apiKey = '90kxvcu9vgdw5stdn7ndmzm68xj2winmkdaklxxygc0js73y';

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleOrderChange = (event) => {
    setOrder(event.target.value);
  };

  const handleEditorChange = (content: string) => {
    setContent(content);
  };

  return (
    <Grid sx={{
      width: '100%',
      padding: '10px',
      '& hr': {
        margin: '10px auto',
      },
    }} container spacing={1}>
      <Grid item xs={12}>
        <Paper sx={{
          padding: '10px',
          display: 'flex',
          overflow: 'auto',
          flexDirection: 'column',
        }}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{
              flexGrow: 1,
              marginBottom: '10px',
            }}
          >
            Dodaj element
          </Typography>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={9}>
              <TextField
                label="Tytuł"
                value={title}
                onChange={handleTitleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Priorytet"
                value={order}
                type='number'
                onChange={handleOrderChange}
                fullWidth
              />
            </Grid>
          </Grid>
          <Editor
            onInit={(_evt, editor) => (editorRef.current = editor)}
            apiKey={apiKey}
            value={content}
            init={getEditorConfiguration(editorRef)}
            onEditorChange={handleEditorChange}
            initialValue=""

          />
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => {
              dispatch(
                createHelpAction({
                  title: title,
                  content: content,
                }),
              );
              navigate(ROUTES.helpManage.href);
            }}
            startIcon={<AddIcon />}
          >
            Dodaj
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
}